import { useNavigate } from 'react-router-dom';

import { Typography, Box } from '@mui/material';
import { ParamsPageWebView } from 'utils/typeServices';

import CarouselCars from 'components/views/CarouselCars';
import ParseWebView from 'components/views/ParseWebView';
import { ButtonRectangle } from 'components/views/form/Button';

import { ReactComponent as IcVehicleExchangeGreen } from 'assets/icons/ic-vehicle-exchange-green.svg';

const ExchangeVehicle = ({ isWebView }: ParamsPageWebView) => {
    const navigate = useNavigate();

    return (
        <ParseWebView title='Troca de veículo' link={isWebView ? '/wb/central-de-trocas' : '/central-de-trocas'} isWebView={isWebView} typePage='subpage'>
            <Box sx={{ margin: { xs: '0rem auto 1.375rem', md: '2.375rem auto 1rem' }, textAlign: 'center' }}>
                <IcVehicleExchangeGreen />
                <Typography sx={{ maxWidth: '25.125rem', fontSize: { xs: '1.125rem', md: '1.25rem' }, margin: '1.1875rem auto 0', lineHeight: '24px' }}>
                    <strong>Selecione o veículo</strong> que será substituído:
                </Typography>
            </Box>

            <CarouselCars />
            <Box sx={{ display: 'flex', paddingTop: '.5rem', justifyContent: 'center', 'button': { width: '100%', maxWidth: '17.5rem', height: '2.5rem' } }}>
                <ButtonRectangle name='CONTINUAR' onClick={() => navigate('perfil', { state: { exchangeVehicle: true } })} />
            </Box>

            <Box sx={{ display: 'flex', paddingTop: { xs: '2rem', md: '3.625rem' }, flexDirection: 'column', alignItems: 'center' }}>
                <Typography fontSize='1rem' color='white' fontWeight={700} padding='9px 2.125rem 4px' sx={{ backgroundColor: 'primary.light', width: 'fit-content', marginBottom: '5px' }}>
                    IMPORTANTE:
                </Typography>
                <Typography lineHeight='19px' textAlign='center' sx={{ maxWidth: '25.5rem', fontSize: { xs: '.875rem', md: '1rem' }, border: '1.4px solid #17A7E0', borderRadius: '5px', padding: { xs: '.875rem .5rem', md: '.875rem 1.6rem' } }}>
                    Na troca de veículo você pode fazer sua cotação,
                    escolher um produto e para a conclusão, nossos
                    atendentes entrarão em contato.
                </Typography>
            </Box>
        </ParseWebView>
    );
}

export default ExchangeVehicle;